export enum TipoContatoEnum {
    CELULAR = "Celular",
    EMAIL = "E-mail",
    TELEFONE_FIXO = "Telefone Fixo"
}